import { makeStyles, Theme, } from '@material-ui/core/styles';

import { USER_PANEL_TYPES, } from 'views/layouts/Header/components/UserPanel';
import menuStripBackground from 'assets/images/menu_strip_background.svg';
import arrowIcon from 'assets/icons/icon_arrow_left_grey.svg';
import arrowHoveredIcon from 'assets/icons/icon_arrow_left_orange.svg';

import {
    headerHeight,
    headerBorderColor,
    headerBackground,
    userEntryBackground,
    userLinkBackground,
    headerLinkColor,
    headerActionButtonColor,
    orangePeel,
    lightningYellow,
} from 'styles/abstract/variables';

type AppBarType = {
    isLogged?: boolean,
};

export const makeAppBarHeaderStyles = makeStyles({
    root: ({ isLogged, }: AppBarType = {}) => Object
        .assign({
            height: headerHeight,
            justifyContent: 'center',
            background: headerBackground,
        },
            isLogged && { borderBottom: `4px solid ${headerBorderColor}`, }
        ),
});

const baseStyles = {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
};

const menuStripBar = {
    base: {
        height: '100%',
        position: 'relative',
    },

    bar: {
        content: "''",
        height: 4,
        width: '100%',
        position: 'absolute',
        bottom: -4,
        left: 0,
        background: `url(${menuStripBackground})`,
    },
};

// TODO PB Set proper type.
export const makeContainerHeaderStyles = makeStyles((theme: Theme): any => ({
    root: {
        ...baseStyles,
        ...menuStripBar.base,

        '&::after': {
            ...menuStripBar.bar,

            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
    },
}));

export const makeGridContainerHeaderStyles = makeStyles({
    container: ({ isLogged, }: AppBarType) => isLogged ? {
        ...menuStripBar.base,

        '&::after': {
            ...menuStripBar.bar,
        },
    } : {},
});

export const makeHeaderStyles = makeStyles({
    title: {
        ...baseStyles,
        fontSize: '1.3rem',
        fontWeight: 400,
        margin: 0,
        justifyContent: 'center',
        '@media (max-width:600px)': {
            justifyContent: 'left',
        }
    },

    iconContainer: {
        ...baseStyles,
        cursor: 'pointer',
    },
});

const userPanelItemType: { [key: string]: object } = {
    [USER_PANEL_TYPES.USER_ACTION]: {
        background: userEntryBackground,
        color: headerActionButtonColor,

        '&:hover': {
            color: orangePeel,
            textDecoration: 'none',
        }
    },

    [USER_PANEL_TYPES.USER_LINK]: {
        background: userLinkBackground,
        color: headerLinkColor,

        '&:hover': {
            background: lightningYellow,
            textDecoration: 'none',
        }
    },
};

type UserPanelItemProps = {
    type?: USER_PANEL_TYPES,
};

export const makeUserPanelStyles = makeStyles((theme: Theme) => ({
    root: {
        ...baseStyles,
        justifyContent: 'flex-end',
        '@media (max-width:1360px)': {
            marginRight: '40px',
        }
    },

    item: ({ type, }: UserPanelItemProps = {}) => Object
        .assign(
            {
                padding: theme.spacing(0, 2),
                fontWeight: 600,
            },
            baseStyles,
            type && userPanelItemType[ type ],
        ),
}));

const navBarLinkStyles = {
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '0.5rem',
    minWidth: 100,
    textDecoration: 'none',

    '&:first-child': {
        marginLeft: 0,
    },

    '&::before': {
        content: "''",
        display: 'inline-block',
        width: 20,
        height: 16,
        background: `url(${arrowIcon}) no-repeat`,
    },

    '&:hover': {
        cursor: 'pointer',
        textDecoration: 'none',

        '&::before': {
            background: `url(${arrowHoveredIcon}) no-repeat`,
        },
    },
};

export const makeNavBarRouterLinkStyles = makeStyles({ navBarRouterLink: navBarLinkStyles });

export const makeNavBarLinkStyles = makeStyles({
    root: navBarLinkStyles
});
